<template>
  <div class="national-Day-activities">
    <img
      class="imgPC"
      src="./image/national-Day-activities-pc.png"
      alt=""
      v-if="isPC"
    />
    <img src="./image/national-Day-activities.png" alt="" v-else />
  </div>
</template>
<script>
export default {
  name: 'national-Day-activities',
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.national-Day-activities {
  width: 100%;
  height: 100vh;
  overflow: auto;
  background-color: #ed5046;
  img {
    width: 100%;
    max-width: 100%;
  }
}
</style>
